import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_ADMIN_SUPABASE_URL as string | undefined;
const supabasePublishableKey = (
  import.meta.env.VITE_ADMIN_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_ADMIN_SUPABASE_ANON_KEY
) as string | undefined;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabasePublishableKey);

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl!, supabasePublishableKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
